export type PlatformLogical =
  | 'hackerrank'
  | 'hackerearth'
  | 'criteriacorp'
  | 'hireflix'
  | 'codeinterview';

export const SUPPORTED_PLATFORMS: PlatformLogical[] = [
  'hackerrank',
  'hackerearth',
  'criteriacorp',
  'hireflix',
  'codeinterview',
];
